import { render } from "./products-filter-page.vue?vue&type=template&id=6e6b5eb9"
import script from "./products-filter-page.vue?vue&type=script&lang=js"
export * from "./products-filter-page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__